import Vue from "vue";
import moment from 'moment';
import './iban.js';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).locale(window.preferred_language).format('DD MMM YYYY')
  }
});

Vue.filter("formatNumber", function (value) {// load a format
  return Number(value).toLocaleString(window.preferred_language, {minimumFractionDigits: 2, maximumFractionDigits: 2}); // displaying other groupings/separators is possible, look at the docs
});
Vue.filter("formatNumberInt", function (value) {// load a format
  return Number(value).toLocaleString(window.preferred_language, {minimumFractionDigits: 0, maximumFractionDigits: 0}); // displaying other groupings/separators is possible, look at the docs
});

Vue.filter("amount2HourMin", function (value, h, m, toEmpty = false) {// load a format
  if(value === undefined||!value||value === 0){
    return (toEmpty) ? '' : '0h 0m'
  }
  var hours = Math.floor(value);
  var minutes = Math.round((value - hours)*60);
  return hours + h + " " + minutes + m;
});

Vue.filter('formatIBAN', (value) => {
  return window.IBAN.printFormat(value)
});
Vue.filter('isValidIBAN', (value) => {
  return window.IBAN.isValid(value)
});

Vue.filter('currency', function(value, currency, decimals) {
  value = parseFloat(value).toFixed(decimals);
  if(!currency || currency === 'EUR') {
      return "€" + value;
  }
  return value + " " + currency;
})